import { render, staticRenderFns } from "./PreferredProduct.vue?vue&type=template&id=e3547a50"
import script from "./PreferredProduct.vue?vue&type=script&lang=js"
export * from "./PreferredProduct.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PreferredProduct.vue?vue&type=style&index=1&id=e3547a50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports